var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          !_vm.isPessoaFisica
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    class:
                      _vm.compararInteressadoAreasPatrimoniais &&
                      _vm.compararInteressadoAreasPatrimoniais.mudouPessoa
                        .mudouCNPJ
                        ? "text"
                        : "",
                    attrs: {
                      label: "CNPJ:",
                      content: _vm.interessado.pessoa.pessoaJuridica.cnpj
                    }
                  }),
                  _c("app-display", {
                    class:
                      _vm.compararInteressadoAreasPatrimoniais &&
                      _vm.compararInteressadoAreasPatrimoniais.mudouPessoa
                        .mudouRazaoSocial
                        ? "text"
                        : "",
                    attrs: {
                      label: "Prefeitura:",
                      content: _vm.interessado.pessoa.pessoaJuridica.razaoSocial
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isPessoaFisica
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    class:
                      _vm.compararInteressadoAreasPatrimoniais &&
                      _vm.compararInteressadoAreasPatrimoniais.mudouPessoa
                        .mudouCPF
                        ? "text"
                        : "",
                    attrs: {
                      label: "CPF do Prefeito:",
                      content: _vm.interessado.pessoa.pessoaFisica.cpf
                    }
                  }),
                  _c("app-display", {
                    class:
                      _vm.compararInteressadoAreasPatrimoniais &&
                      _vm.compararInteressadoAreasPatrimoniais.mudouPessoa
                        .mudouNome
                        ? "text"
                        : "",
                    attrs: {
                      label: "Nome do Prefeito:",
                      content: _vm.interessado.pessoa.pessoaFisica.nome
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c(
                "app-collapse",
                { attrs: { title: "Endereço" } },
                [
                  _c("informacoes-endereco", {
                    attrs: {
                      slot: "body",
                      endereco: _vm.enderecoInteressado,
                      mudouEndereco:
                        _vm.compararInteressadoAreasPatrimoniais &&
                        _vm.compararInteressadoAreasPatrimoniais.mudouEndereco
                    },
                    slot: "body"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-891057e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-891057e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/areasPatrimoniais/InformacoesInteressadoAreasPatrimoniais.vue
// module id = null
// module chunks = 